module.exports = __webpack_public_path__ + "img/Frame 352238.f2f3a20d.png";